import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { updatePreparationTime, updateDeliveryTime, setAlert } from "../../reducers/userConfigSlice";
import { getOrderManagerActiveCategories, getOrderManagerSalesChannel, updateDeliveryTimeConfig, updatePreparationTimeConfig } from "../../api/kd";
import { Datatable } from "@delibrandev/utils";

const TimeSetting = ({ id, label, value, managerId, save, update }) => {
  const dispatch = useDispatch();
  const [draft, setDraft] = useState(value ?? "");
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");
  const inFlight = useRef(false);
  useEffect(() => { setDraft(value ?? ""); setError(""); }, [value, managerId]);
  const valid = managerId && draft !== "" && Number.isSafeInteger(Number(draft)) && Number(draft) > 0;
  const options = [...new Set([10, 20, 30, 40, ...(Number(value) > 0 ? [Number(value)] : [])])].sort((a, b) => a - b);
  const submit = async () => {
    if (!valid || inFlight.current) return;
    inFlight.current = true; setSaving(true); setError("");
    const minutes = Number(draft);
    try {
      const response = await save(managerId, { [id]: minutes });
      if (response?.error !== false) throw new Error("save-failed");
      dispatch(update(minutes));
      dispatch(setAlert({ called: true, title: "Completado", message: "Los cambios se han aplicado con éxito", type: "success" }));
    } catch {
      setError("No se pudo guardar el tiempo. Conservamos tu selección; vuelve a intentarlo.");
    } finally { inFlight.current = false; setSaving(false); }
  };
  return <div className="col-md-6 col-sm-12 pb-4"><div className="adminPanel m-2" aria-busy={saving}>
    <div className="flex-gap"><label htmlFor={`manager-${id}`}><b>{label}</b></label>
      <button type="button" className="customButton" aria-label={`Guardar ${label.toLowerCase()}`} onClick={submit} disabled={!valid || saving}>{saving ? "Guardando…" : "Actualizar"}</button>
    </div>
    <div className="selectContainer"><div className="inputDescription" id={`manager-${id}-hint`}>Seleccione un tiempo estimado</div>
      <select className="customSelect" id={`manager-${id}`} value={draft} onChange={event => setDraft(event.target.value)} disabled={saving || !managerId} aria-describedby={`manager-${id}-hint`}>
        <option value="" disabled>Selecciona un tiempo</option>
        {options.map(minutes => <option key={minutes} value={minutes}>{minutes} minutos</option>)}
      </select>
    </div>
    {error && <p role="alert">{error}</p>}
  </div></div>;
};

export const Settings = () => {
  const managerConfig = useSelector((state) => state.aplicationConfig.managerConfig);
  const [salesChannels, setSalesChannels] = useState([]);
  const [activeCategories, setActiveCategories] = useState([]);
  const query = async () => {
    const response = await getOrderManagerSalesChannel();
    if (response && !response.error) {
      setSalesChannels(Array.isArray(response.data) ? response.data.filter((channel) => channel.isActive !== false) : []);
    }

    const response2 = await getOrderManagerActiveCategories();
    if (response2 && !response2.error) {
      setActiveCategories(Array.isArray(response2.data) ? response2.data.filter((category) => category.isActive !== false) : []);
    }
  };

  useEffect(() => {
    query();
  }, []);
  const sections = [{ text: null, callback: () => null, actions: ["search"], actionsWithSelect: [] }];
  const customHeaders = {
    name: "Nombre",
    description: "Descripción",
    productCount: "Nº de productos",
  };
  const customData = {};

  return (
    <div className="orders-display kd-settings">
      <h4 className="">Configuración</h4>
      <div className="row">
        <TimeSetting id="preparationTime" label="Tiempo de preparación" value={managerConfig.preparationTime} managerId={managerConfig.orderManagerConfigurationId} save={updatePreparationTimeConfig} update={updatePreparationTime} />
        <TimeSetting id="deliveryTime" label="Tiempo de entrega" value={managerConfig.deliveryTime} managerId={managerConfig.orderManagerConfigurationId} save={updateDeliveryTimeConfig} update={updateDeliveryTime} />
      </div>
      <div className="row">
        <div className="col-md-6 col-sm-12 pb-4">
          <div className="adminPanel m-2">
            <div className="flex-start p-2">
              <b>Categorías activas en este punto de venta</b>
            </div>
            <Datatable data={activeCategories} customHeaders={customHeaders} customData={customData} sections={sections} />
          </div>
        </div>
        <div className="col-md-6 col-sm-12 pb-4">
          <div className="adminPanel m-2">
            <div className="flex-start p-2">
              <b>Canales de venta activos en este punto de venta</b>
            </div>
            <Datatable data={salesChannels} customHeaders={customHeaders} customData={customData} sections={sections} />
          </div>
        </div>
      </div>
    </div>
  );
};
